import { useMeasurementInfo } from "@/hooks/measurement/use-measurement-info";
import { UseMeasurementFetchParams } from "@/types/measurement/measurement";
import { FC } from "react";
import { Navigate, Outlet } from "react-router";

const MeasurementCreationGuard: FC<{
  type: NonNullable<UseMeasurementFetchParams["query"]>["type"];
  range?: number;
  fallbackPage?: string;
}> = ({ type, range = 7, fallbackPage = "." }) => {
  const { canCreate } = useMeasurementInfo(type, range);
  return canCreate ? <Outlet /> : <Navigate to={fallbackPage} replace />;
};
MeasurementCreationGuard.displayName = "MeasurementCreationGuard";

export default MeasurementCreationGuard;
